import { DetailedHTMLProps, ReactNode, TdHTMLAttributes } from 'react';
import clsx from 'clsx';

type TdProps = {
  children: ReactNode;
  isFirstCell?: boolean;
  isLastCell?: boolean;
} & DetailedHTMLProps<
  TdHTMLAttributes<HTMLTableCellElement>,
  HTMLTableCellElement
>;

export const Td = ({
  children,
  className,
  isFirstCell,
  isLastCell,
  ...tdProps
}: TdProps) => (
  <td
    className={clsx(
      'border-r border-gray-100',
      isFirstCell && 'rounded-tl-2xl border-l',
      isLastCell && 'rounded-tr-2xl',
      className,
    )}
    {...tdProps}
  >
    {children}
  </td>
);
